import { createStore, Store, useStore as useVuexStore } from 'vuex'
import { IRootState, IStoreType } from './type'
import login from './login/login'
import { getInfo } from '@/service/login'
import system from './main/system/system'
import dict from './dict/dict'
import user from './user/user'
import permission from './main/system/permission'
import app from './app/app'
import settings from './setting/settings'
import tagsView from './tagsView/tagsView'
import { getPageListData } from '@/service/main/system/system'
const axios = require('axios')
const store = createStore<IRootState>({
  state: () => {
    return {
      token: '',
      expires_in: 0,
      id: '',
      name: '',
      avatar: '',
      permissions: [],
      roles: [],
      menu: [],
      user: {}
    }
  },
  mutations: {
    SET_TOKEN: (state, token: string) => {
      state.token = token
    },
    setId: (state, id: string) => {
      state.id = id
    },
    setName: (state, name: string) => {
      state.name = name
    },
    setAvatar: (state, avatar: string) => {
      state.avatar = avatar
    },
    changePermissions(state, list: any[]) {
      console.log('changePermissions',list)
      state.permissions = list
    },
    changeRoles(state, list: any[]) {
      state.roles = list
    },
    changeMenu(state, list) {
      state.menu = list
    }
  },
  getters: {},
  actions: {
    async getInitiaDataAction({ commit },permissions) {
      //const { data: menuResult } = await axios.get('./menuList.json')
      
      //const { list: menuList } = menuResult.data

      // 2.保存数据
      //commit('changeMenu', menuList)
      console.log(permissions,'permissions')
      commit('changePermissions',permissions)
    },
    // 获取用户信息
    GetInfo({ commit }) {
      return new Promise<any>((resolve, reject) => {
        getInfo().then(res => {
          const user = res.user
          const avatar = (user.avatar == "" || user.avatar == null) ? require("@/assets/images/profile.jpg") : user.avatar;
          if (res.roles && res.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('changeRoles', res.roles)
            commit('changePermissions', res.permissions)
          } else {
            commit('changeRoles', ['ROLE_DEFAULT'])
          }
          commit('setId', user.userId)
          commit('setName', user.userName)
          commit('setAvatar', avatar)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

  },
  modules: {
    login,
    system,
    dict,
    user,
    permission,
    app,
    settings,
    tagsView
  }
})
export function setUpState() {
  store.dispatch('login/loadLocalLogin')
  // store.dispatch('getInitiaDataAction')
}
export function useStore(): Store<IStoreType> {
  return useVuexStore()
}
export default store
